/**
 * Progress Bar Module
 * Animuje pasek postępu po wejściu komponentu do viewport.
 * Konfiguracja przez atrybuty data-*:
 *
 * data-progress-current  — ilość odebranych (domyślnie 0)
 * data-progress-max      — ilość do odblokowania (wymagany)
 * data-progress-title    — tytuł (stan normalny)
 * data-progress-title-success — tytuł (stan sukcesu)
 * data-progress-desc     — opis (stan normalny)
 * data-progress-desc-success  — opis (stan sukcesu)
 * data-progress-subtitle-template — szablon podtytułu, np. "{current} / {max} odebranych voucherów"
 *
 * Użycie HTML:
 *   <div class="progress-bar"
 *        data-progress-current="3"
 *        data-progress-max="6"
 *        data-progress-title="Postęp odblokowania nagrody specjalnej"
 *        data-progress-title-success="Nagroda specjalna odblokowana!"
 *        data-progress-desc="Odbierz 6 voucherów, aby odblokować nagrodę specjalną."
 *        data-progress-desc-success="Gratulacje! Nagroda specjalna została odblokowana."
 *        data-progress-subtitle-template="{current} / {max} odebranych voucherów">
 *     <p class="progress-bar__title"></p>
 *     <p class="progress-bar__subtitle"></p>
 *     <div class="progress-bar__track">
 *       <div class="progress-bar__fill"></div>
 *     </div>
 *     <p class="progress-bar__desc"></p>
 *   </div>
 */

(function () {
    'use strict';

    var SELECTOR = '.progress-bar[data-progress-max]';
    var ANIMATION_DURATION = 800; // ms — czas animacji licznika
    var SUCCESS_DELAY = 300;      // ms — opóźnienie zmiany na sukces po zakończeniu animacji

    /**
     * Odczytuje konfigurację z data-* atrybutów
     */
    function getConfig(el) {
        var max = parseInt(el.getAttribute('data-progress-max'), 10) || 1;
        var current = parseInt(el.getAttribute('data-progress-current'), 10) || 0;

        return {
            current: Math.min(current, max),
            max: max,
            title: el.getAttribute('data-progress-title') || '',
            titleSuccess: el.getAttribute('data-progress-title-success') || '',
            desc: el.getAttribute('data-progress-desc') || '',
            descSuccess: el.getAttribute('data-progress-desc-success') || '',
            subtitleTemplate: el.getAttribute('data-progress-subtitle-template') || '{current} / {max}'
        };
    }

    /**
     * Formatuje szablon podtytułu
     */
    function formatSubtitle(template, current, max) {
        return template
            .replace('{current}', current)
            .replace('{max}', max);
    }

    /**
     * Ustawia stan początkowy (bez animacji)
     */
    function setInitialState(el, config) {
        var titleEl = el.querySelector('.progress-bar__title');
        var subtitleEl = el.querySelector('.progress-bar__subtitle');
        var fillEl = el.querySelector('.progress-bar__fill');
        var descEl = el.querySelector('.progress-bar__desc');

        // Ustaw teksty na stan normalny z current=0
        if (titleEl) titleEl.textContent = config.title;
        if (subtitleEl) subtitleEl.textContent = formatSubtitle(config.subtitleTemplate, 0, config.max);
        if (fillEl) fillEl.style.setProperty('--progress', '0%');
        if (descEl) descEl.textContent = config.desc;
    }

    /**
     * Animacja licznika od 0 do target
     */
    function animateCounter(el, config) {
        var subtitleEl = el.querySelector('.progress-bar__subtitle');
        if (!subtitleEl) return;

        var startTime = null;
        var target = config.current;

        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            var elapsed = timestamp - startTime;
            var progress = Math.min(elapsed / ANIMATION_DURATION, 1);

            // Easing — ease-out cubic
            var eased = 1 - Math.pow(1 - progress, 3);
            var currentValue = Math.round(eased * target);

            subtitleEl.textContent = formatSubtitle(config.subtitleTemplate, currentValue, config.max);

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    /**
     * Animacja paska postępu
     */
    function animateBar(el, config) {
        var fillEl = el.querySelector('.progress-bar__fill');
        if (!fillEl) return;

        var percentage = (config.current / config.max) * 100;

        // Dodaj klasę animated żeby włączyć CSS transition
        el.classList.add('progress-bar--animated');

        // Małe opóźnienie żeby transition zdążył się zarejestrować
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                fillEl.style.setProperty('--progress', percentage + '%');
            });
        });
    }

    /**
     * Przełączenie na stan sukcesu z płynną animacją wysokości
     */
    function switchToSuccess(el, config) {
        var titleEl = el.querySelector('.progress-bar__title');
        var descEl = el.querySelector('.progress-bar__desc');

        // 1. Zablokuj aktualną wysokość + wyłącz overflow clipping
        // var currentHeight = el.offsetHeight;
        // el.style.height = currentHeight + 'px';
        el.style.overflow = 'visible';

        // 2. Zmień treść i klasę
        requestAnimationFrame(function () {
            el.classList.add('progress-bar--success');
            if (titleEl && config.titleSuccess) titleEl.textContent = config.titleSuccess;
            if (descEl && config.descSuccess) descEl.textContent = config.descSuccess;

            // 3. Zmierz nową wysokość przez scrollHeight
            // var newHeight = el.scrollHeight;
            // el.style.height = newHeight + 'px';
            // 4. Force reflow, potem animuj do nowej wysokości
            // el.offsetHeight;
            // requestAnimationFrame(function () {


            //     // 5. Po zakończeniu transition — przywróć overflow i height
            //     function onTransitionEnd(e) {
            //         if (e.propertyName === 'height') {
            //             el.style.height = '';
            //             el.style.overflow = '';
            //             el.removeEventListener('transitionend', onTransitionEnd);
            //         }
            //     }
            //     el.addEventListener('transitionend', onTransitionEnd);
            // });
        });
    }

    /**
     * Uruchamia pełną animację komponentu
     */
    function triggerAnimation(el) {
        var config = getConfig(el);
        var isSuccess = config.current >= config.max;

        // Animuj licznik i pasek jednocześnie
        animateCounter(el, config);
        animateBar(el, config);

        // Jeśli sukces — zmień stan po zakończeniu animacji
        if (isSuccess) {
            setTimeout(function () {
                switchToSuccess(el, config);
            }, ANIMATION_DURATION + SUCCESS_DELAY);
        }
    }

    /**
     * IntersectionObserver — jednorazowa animacja po wejściu do viewport
     */
    function initObserver() {
        var elements = document.querySelectorAll(SELECTOR);
        if (!elements.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    triggerAnimation(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.3
        });

        elements.forEach(function (el) {
            var config = getConfig(el);
            setInitialState(el, config);
            observer.observe(el);
        });
    }

    // Inicjalizacja po załadowaniu DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObserver);
    } else {
        initObserver();
    }
})();
